import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}